import React from 'react'
import {CardHeader, SignInLayout, Card, BrandFooter} from '../../components/SigninLayout'
import styled, {css} from 'styled-components'
import {Button, Icon} from '@startlibs/components'

const ExpiredPageLayout = styled(SignInLayout) `
  color: rgba(0,0,0,0.5);
  h1 {
    margin-bottom: 0.5rem;
    font-size: 22px;
  }
`

export const ExpiredPage = ({providerInfo}) => <ExpiredPageLayout providerInfo={providerInfo}>
  <Card>
    <CardHeader>
      <h1>This study is no longer available.</h1>
    </CardHeader>
    <p>The shared study link you are accessing has expired and you are no longer able to access it.</p>
    <p>
      In case you need to be granted access again, please reach out to the person
      who shared this study in order to have it shared again.
    </p>
    <BrandFooter/>
  </Card>

</ExpiredPageLayout>